export default __webpack_public_path__ + "media/images/bg_button_span-2572436db9e51b7286ab26a41322c541.gif";